import { takeWhile } from 'rxjs';
import { OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AlertService } from './../../../layout/common/alert-panel/alert.service';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'mojo-desktop-alert',
    templateUrl: './desktop-alert.component.html',
    standalone: false
})
export class DesktopAlertComponent implements OnInit, OnDestroy {

isAlive = true;

  constructor(private readonly alertService: AlertService,
    private readonly toastr: ToastrService) {

  }
  ngOnDestroy(): void {
    this.isAlive = false;
  }

  ngOnInit(): void {
    this.alertService.alerts$.pipe(takeWhile(() => this.isAlive)).subscribe((alert) => {
      switch (alert.type) {
        case 'success':
          this.toastr.success(alert.message, alert.title);
          break;
        case 'error':
          this.toastr.error(alert.message, alert.title);
          break;
        case 'info':
          this.toastr.info(alert.message, alert.title);
          break;
      }
      alert.dismissed = true;
    });
  }

}
